<div class="flex justify-center">
  <div class="container my-2" #mainTracker>
    <iframe
      class="iframe-livetracker"
      [src]="linkLiveTracker()"
      name="myiFrame"
      scrolling="no"
      frameborder="0"
    ></iframe>
  </div>
</div>

<!-- Floating Tracker -->
@if(isTrackerHidden && viewLiveTracker && onlyViewTrackerByStatusMatch()){

<div class="floating-tracker">
  <iframe
    class="iframe-livetracker"
    [src]="linkLiveTracker()"
    name="smallTracker"
    scrolling="no"
    frameborder="0"
  ></iframe>
</div>
}
